import { render } from "./CheckoutThanks.vue?vue&type=template&id=0fc69edf"
import script from "./CheckoutThanks.vue?vue&type=script&lang=js"
export * from "./CheckoutThanks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__